// 導入圖表組件國際化
import echartsfn from "./echartsfn.js";

// 主登入頁面內容
const main = {
  // 頁面標題和歡迎信息
  title: "進入系統",
  Platformcount: "平台數據統計",
  PlatformcountUnit: "億",
  tagtotal: "標籤總量",
  malicetag: "惡意標籤",
  Entitytag: "實體標籤",
  behaviortag: "行為標籤",
  Maliciousmonitoring: "惡意地址風險監控",
  TransferTrend: "惡意地址轉賬趨勢圖",
};

// 幣種數據頁面內容
const currencydata = {
  // 頁面標題
  coinDataTitle: "幣種數據",
  coinDataUnit: "(單位：USDT)",
  todayTransactionTitle: "今日大額交易監測",
  exchangeRankingsTitle: "交易所24小時成交額排行榜",

  // 數據標籤
  priceLabel: "價格",
  tradingVolumeLabel: "交易總量",
  tradingAddressLabel: "交易地址",

  // 表格表頭
  rankLabel: "排名",
  exchangeLabel: "交易所",
  volume24hLabel: "24H成交額($)",
  supportedCoinsLabel: "支持交易幣種",

  // 狀態提示
  // loadingText: "拼命載入中",
  // noDataText: "暫無數據",

  // 交易描述
  transferText: "轉",
  toText: "至",
  transferToText: "轉到",
};

// 圖鏈安全頁面內容
const graphSecurity = {
  // 頁面標題
  graphSecurityTitle: "圖鏈安全",
  labReportTitle: "實驗室研究報告",

  // 標籤頁
  phishingFraudTab: "釣魚詐騙",
  multiSignFraudTab: "多簽詐騙",

  // 圖表標題
  fraudAddressCountTitle: "釣魚詐騙受害者地址數量",
  fraudAmountStatTitle: "被騙金額統計",
  victimAddressCountTitle: "受害者地址數量",
  fraudFeeAddressActiveTitle: "詐騙手續費地址活躍",

  // 單位
  addressCountUnit: "個",
  amountUnit: "萬 USDT",

  // 報告標題
  phishingReportTitle: "釣魚詐騙報告",
  multiSignReportTitle: "多簽授權詐騙報告",

  // 報告描述
  phishingReportDesc:
    "圖鏈安全實驗室對波場（Tron）鏈上多簽授權詐騙進行調查和披露，揭示詐騙團伙的具體作案手法，希望能為公眾提供安全警示與建議。",
  multiSignReportDesc:
    "圖鏈安全實驗室通過對區塊鏈釣魚詐騙數據監測以及深入分析，我們發現攻擊者利用高度相似地址偽裝真實地址的手法越來越狡猾，使得用戶在轉賬時容易產生誤判，導致資產的損失。",
};

// 地圖頁面內容
const mapPage = {
  // 案件統計標籤
  caseJudgmentCountLabel: "[判例數量]",
  indictmentCountLabel: "[起訴書數量]",

  // 數據說明
  incompleteStatisticsTitle: "數據不完全統計",
};

export default {
  ...main,
  ...currencydata,
  ...graphSecurity,
  ...mapPage,
  ...echartsfn,
  // 子模組
};
